import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/logo.svg'


const _hoisted_1 = { class: "flex justify-between mb-m" }
const _hoisted_2 = { class: "flex" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "w-profile h-profile mr-s"
}, null, -1)

import { ref } from "vue";
import { supabase } from "@/helpers/supabase";
import {
  bytesToHex,
  createKeyPair,
  encryptCareProviderGroupKeyForCareProviderGroup,
} from "@/helpers/encryption";

import { usePublicStore } from "@/store/publicStore";
import { useAccountStore } from "@/store/accountStore";
import { useSessionStore } from "@/store/sessionStore";
import { getColor } from "@/helpers/colorhelper";
import ProfileCircle from "@/components/ProfileCircle.vue";
import { useNotificationStore } from "@/store/notificationStore";
import UmanaHeadline from "@/components/UmanaHeadline.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'CreateCareProviderGroupView',
  setup(__props) {

const accountStore = useAccountStore();
const sessionStore = useSessionStore();
const color = ref<string>(getColor());

const loading = ref(false);
const careProviderGroup = ref<any>({});

const createCareProviderGroup = async () => {
  const publicStore = usePublicStore();

  if (sessionStore.keyPair == null) {
    useNotificationStore().notifications.push({
      msg: `Fehler Session-Store nicht vorhanden - #ccpgv01`,
      type: "danger",
    });
    return;
  }

  try {
    loading.value = true;
    let careProviderGroupKeyPair = await createKeyPair();
    let result = await supabase.rpc("create_careprovider_group", {
      _group_name: careProviderGroup.value.name,
      _short_name: careProviderGroup.value.shortName,
      _address1: careProviderGroup.value.address1,
      _address2: careProviderGroup.value.address2 ?? "",
      _zip: careProviderGroup.value.zip,
      _city: careProviderGroup.value.city,
      _is_orderer: careProviderGroup.value.isOrderer == true,
      _is_shop: careProviderGroup.value.isShop == true,
      _color: color.value,
      _public_key: bytesToHex(careProviderGroupKeyPair.publicKey),
      _encrypted_private_key: bytesToHex(
        await encryptCareProviderGroupKeyForCareProviderGroup(
          sessionStore.keyPair.publicKey,
          careProviderGroupKeyPair.privateKey
        )
      ),
      _used_public_key: sessionStore.publicKeyId,
    });

    await accountStore.loadCpgs();
    publicStore.loadPublicStore();

    if (result.error) throw result.error;
  } catch (error) {
    if (error instanceof Error) {
      useNotificationStore().notifications.push({
        msg: `Fehler - Unternehmen konnte nicht erstellt werden. #cpc01: ${error}`,
        type: "danger",
      });
    }
  } finally {
    loading.value = false;
  }
};

function newColor() {
  color.value = getColor();
}

return (_ctx: any,_cache: any) => {
  const _component_FormKit = _resolveComponent("FormKit")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", null, [
        _createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          _createVNode(UmanaHeadline, { h: "h1" }, {
            default: _withCtx(() => [
              _createTextVNode("mediBe")
            ]),
            _: 1
          })
        ]),
        _createVNode(UmanaHeadline, { h: "h2" }, {
          default: _withCtx(() => [
            _createTextVNode("Leistungserbringer erstellen")
          ]),
          _: 1
        })
      ]),
      _createVNode(ProfileCircle, {
        onClick: _cache[0] || (_cache[0] = ($event: any) => (newColor())),
        "care-provider-group": {
          id: 0,
          created_at: 'j',
          owner: '',
          group_name: '',
          short_name: careProviderGroup.value.shortName,
          color: color.value,
          is_orderer: false,
          is_shop: false,
          medication_status_after_scan: 0,
          propharma_id: null,
          preferred_weekday: null,
        }
      }, null, 8, ["care-provider-group"])
    ]),
    _createVNode(_component_FormKit, {
      type: "form",
      onSubmit: createCareProviderGroup,
      modelValue: careProviderGroup.value,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((careProviderGroup).value = $event)),
      "submit-label": "Unternehmen erstellen"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_FormKit, {
          required: "",
          type: "text",
          validation: "required",
          name: "name",
          helper: "Name",
          label: "Name"
        }),
        _createVNode(_component_FormKit, {
          required: "",
          type: "text",
          name: "shortName",
          maxlength: "3",
          label: "Kürzel",
          validation: "required"
        }),
        _createVNode(_component_FormKit, {
          required: "",
          type: "text",
          name: "address1",
          label: "Adresse",
          validation: "required"
        }),
        _createVNode(_component_FormKit, {
          type: "text",
          name: "address2",
          label: "2. Adresszeile"
        }),
        _createVNode(_component_FormKit, {
          required: "",
          type: "text",
          name: "zip",
          maxlength: "4",
          label: "PLZ",
          validation: "required"
        }),
        _createVNode(_component_FormKit, {
          required: "",
          type: "text",
          name: "city",
          label: "Stadt",
          validation: "required"
        }),
        _createVNode(_component_FormKit, {
          type: "checkbox",
          name: "isOrderer",
          maxlength: "4",
          label: "Bestellt Medikamente",
          help: "Das Unternehmen bestellt Medikamente an ein anderes Unternehmen"
        }),
        _createVNode(_component_FormKit, {
          type: "checkbox",
          name: "isShop",
          maxlength: "4",
          label: "Liefert Medikamente",
          help: "Das Unternehmen liefert Medikamente an ein anderes Unternehmen"
        })
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})